import React from 'react'
import Button from '../components/Button';
import FlowStep from '../components/FlowStep';
import {useNavigate} from "react-router-dom";

const StepFlow = () => {

    const navigate = useNavigate();

    const handleNext = () => {
        navigate('/nfc');
    };

    return (
        <div className='mobile-container'>
            <div className='margin-top-section'/>
            <p className='large-text gmarket-font'>아래 순서로 진행하세요</p>
            <div className='margin-bottom-section'/>

            <div className="flow-container">
                <FlowStep stepNumber="1">
                    휴대폰 GPS 위치 기능<strong>ON</strong> 확인
                </FlowStep>

                <FlowStep stepNumber="2">
                    휴대폰 NFC 읽기 기능<strong>ON</strong> 확인
                </FlowStep>

                <FlowStep stepNumber="3">
                    카메라 기능을 열고 QR 인식 접속
                </FlowStep>

                <FlowStep stepNumber="4">
                    본인 아이디 / 패스워드 직접 입력
                </FlowStep>

                <FlowStep stepNumber="5">
                    휴대폰 뒷면을 QR로고에 접촉 후 인식
                </FlowStep>

                <FlowStep stepNumber="6">
                    사업장 / 공지사항 확인 후 다음 클릭
                </FlowStep>

                <FlowStep stepNumber="7">
                    점검사항 체크 / 점검사항 사유작성
                </FlowStep>

                <FlowStep stepNumber="8">
                    특이사항 입력 후 사진 업로드 클릭
                </FlowStep>

                <FlowStep stepNumber="9">
                    점검장소 사진 1매 촬영 증빙 저장
                </FlowStep>

                <FlowStep stepNumber="10">
                    제출클릭 후 순찰목록 우측 보기 클릭
                </FlowStep>

                <FlowStep stepNumber="11">
                    휴대폰 저장 후 SMS 전달하기 클릭
                </FlowStep>

                <FlowStep stepNumber="10">
                    저장된 번호로 리포트 발송 됩니다.
                </FlowStep>
            </div>
            <div>
                <p style={{fontSize:'15px'}}>※ 웹사이트는 크롬(구글)에서만 작동합니다</p>

                <p style={{fontSize:'15px'}}>
                    ※ 아이폰 사용자는 NFC 인식이 불가하므로<br/>
                    직접 대덕시큐리티 사이트 접속 후<br/>
                    QR로고 인식 후 사업장 정보를 확인할 수 있습니다<br/><br/>
                </p>
            </div>
            <Button className='next-button gmarket-font' onClick={handleNext}>다음</Button>
        </div>
    )
}

export default StepFlow